<script setup>
// Меню панелі плеєра: кнопка + випадний блок.
//
// sheet — на телефоні відкрите меню переноситься на рівень сторінки (у
// фулскріні — у сам плеєр) і стає шторкою знизу з затемненням. Інакше воно
// лишається всередині панелі плеєра, а та — окремий шар (z-10): жоден
// z-index не підніме меню вище значків серій під плеєром і кнопки чату, і
// шторка опинялась під ними
const props = defineProps({
  sheet: { type: Boolean, default: false }
})

const wrapper = ref()
const panel = ref()
const isOpen = ref(false)
// Меню могло переїхати в body — клік по ньому не має вважатись кліком «повз»
onClickOutside(wrapper, () => (isOpen.value = false), { ignore: [panel] })
useEventListener('keydown', (e) => {
  if (e.key === 'Escape' && isOpen.value) isOpen.value = false
})

const open = () => (isOpen.value = true)
const close = () => (isOpen.value = false)
const toggle = () => (isOpen.value = !isOpen.value)

const narrow = useMediaQuery('(max-width: 639px)')
// Куди переносити: у фулскріні поза плеєром нічого не видно
const target = ref('body')
const asSheet = computed(() => props.sheet && isOpen.value && narrow.value)

watch(asSheet, (value) => {
  if (value && import.meta.client) {
    target.value = document.fullscreenElement || document.webkitFullscreenElement || 'body'
  }
})

// Плеєр питає, чи відкрите меню: поки людина в ньому щось вибирає, панель
// керування не ховається (на телефоні вона інакше їхала разом із меню)
defineExpose({ isOpen, close })
</script>

<template>
  <div
    ref="wrapper"
    class="relative"
  >
    <slot
      :open="open"
      :toggle="toggle"
    />
    <Teleport
      :to="target"
      :disabled="!asSheet"
    >
      <!-- Затемнення під шторкою: тап по ньому закриває меню -->
      <div
        v-if="asSheet"
        class="z-[2147483003] fixed inset-0 bg-black/50"
        @click="close"
      />
      <div
        ref="panel"
        :class="[
          { 'pointer-events-none opacity-0': !isOpen },
          asSheet ? 'relative z-[2147483004]' : ''
        ]"
      >
        <slot
          name="menu"
          :is-open="isOpen"
          :close="close"
        />
      </div>
    </Teleport>
  </div>
</template>
